export class MVMBaseTabModel {
    title: string;
    inWell = true;
    order: number;
}
